import { alpha, IconButton, InputBase, styled } from '@mui/material';

export const SearchInput = styled(InputBase)(({ theme }) => ({
  color: 'inherit',
  borderRadius: '32px',
  border: `1px solid ${theme.palette.secondary.main}`,
  padding: '0 18px',
  '& .MuiInputBase-input': {
    width: '200px',
    padding: '10px 0 10px',
    transition: theme.transitions.create('width'),
    [theme.breakpoints.up('md')]: {
      width: '200px',
      '&:focus': {
        width: '300px',
      },
    },
  },
  '& .MuiInputAdornment-positionStart': {
    color: theme.palette.secondary.main,
  },
  '&.Mui-disabled': {
    borderColor: alpha(theme.palette.common.grey, 0.4),
    '& .MuiInputAdornment-positionStart': {
      color: alpha(theme.palette.common.grey, 0.4),
    },
  },
}));

export const ClearSearchButton = styled(IconButton)(({ theme }) => ({
  padding: '4px',
  '& span': {
    fontSize: '20px',
    color: theme.palette.secondary.main,
  },
}));
